import { render, staticRenderFns } from "./ListChips.vue?vue&type=template&id=45bf9326&"
import script from "./ListChips.vue?vue&type=script&lang=js&"
export * from "./ListChips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports